import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';
import { CompanyCmd, CompanyCmdWithDevices } from './companyCmd.types';

const companyCmdApiPath = (companyId: string) => `/companies/${companyId}/cmd`;

export const sendCmdAPI = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: CompanyCmd;
}): Promise<AxiosResponse<CompanyCmd & ApiError>> => {
  return instance
    .post<CompanyCmd>(companyCmdApiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const getCmdAPI = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<CompanyCmdWithDevices>> => {
  return instance
    .get<CompanyCmdWithDevices>(companyCmdApiPath(companyId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteCmdAPI = async ({ companyId }: { companyId: string }): Promise<AxiosResponse<void>> => {
  return instance.delete<void>(companyCmdApiPath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

const companyHeadsetCmdApiPath = (companyId: string, headsetId: string) =>
  `${companyCmdApiPath(companyId)}/${headsetId}`;

export const sendHeadsetCmdAPI = async ({
  companyId,
  headsetId,
  data,
}: {
  companyId: string;
  headsetId: string;
  data: CompanyCmd;
}): Promise<AxiosResponse<CompanyCmd & ApiError>> => {
  return instance
    .post<CompanyCmd>(companyHeadsetCmdApiPath(companyId, headsetId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteHeadsetCmdAPI = async ({
  companyId,
  headsetId,
}: {
  companyId: string;
  headsetId: string;
}): Promise<AxiosResponse<void>> => {
  return instance
    .delete<void>(companyHeadsetCmdApiPath(companyId, headsetId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
